import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { API } from "@/lib/api";

const WELCOME = { role: "bot", text: "Hi! I'm Sparkle, the Tooth Buds helper. Ask me anything about your child's teeth - teething, brushing, cavities, emergencies or our clinic. I'll give you clear, guideline-based advice." };

const guestId = () => {
  let id = localStorage.getItem("tb_chat_session");
  if (!id) { id = `s_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`; localStorage.setItem("tb_chat_session", id); }
  return id;
};

async function stream(res, onDelta) {
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) return;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const data = p.replace(/^data: /, "");
      if (data === "[DONE]") return;
      const ev = JSON.parse(data);
      onDelta(ev.delta || ev.error || "");
    }
  }
}

export function useSparkle() {
  const { isSignedIn, getToken } = useAuth();
  const [msgs, setMsgs] = useState([WELCOME]);
  const [busy, setBusy] = useState(false);

  const headers = useCallback(async () => {
    const token = isSignedIn ? await getToken() : null;
    return { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) };
  }, [isSignedIn, getToken]);

  useEffect(() => {
    if (!isSignedIn) { setMsgs([WELCOME]); return; }
    (async () => {
      const res = await fetch(`${API}/chat/history`, { headers: await headers() });
      if (!res.ok) return;
      const items = await res.json();
      setMsgs([WELCOME, ...items.map((m) => ({ role: m.role === "parent" ? "user" : "bot", text: m.text }))]);
    })();
  }, [isSignedIn, headers]);

  const send = async (q) => {
    if (!q.trim() || busy) return;
    setBusy(true);
    setMsgs((m) => [...m, { role: "user", text: q }, { role: "bot", text: "" }]);
    const append = (d) => setMsgs((m) => { const c = [...m]; c[c.length - 1] = { role: "bot", text: c[c.length - 1].text + d }; return c; });
    try {
      const res = await fetch(`${API}/chat`, { method: "POST", headers: await headers(), body: JSON.stringify({ session_id: guestId(), message: q }) });
      if (!res.ok) { const e = await res.json().catch(() => ({})); append(e.detail || "Sorry, I couldn't answer right now."); }
      else await stream(res, append);
    } catch {
      append("Oops, I couldn't connect. Please call +91 98206 49411.");
    }
    setBusy(false);
  };

  const clear = async () => {
    if (isSignedIn) await fetch(`${API}/chat/history`, { method: "DELETE", headers: await headers() });
    else localStorage.removeItem("tb_chat_session");
    setMsgs([WELCOME]);
  };

  return { msgs, busy, send, clear, isSignedIn };
}
